// extracted by mini-css-extract-plugin
export var chevronIcon = "_ci-2";
export var teamName = "_ci-1";
export var teamSwitcherButton = "_ci-0";